import { useTranslation } from 'react-i18next'
import { Alert } from '@/components/ui/Alert'
import { useChallenges } from '../hooks/useChallenges'
import { ChallengeCard } from './ChallengeCard'
import { CreateChallengeForm } from './CreateChallengeForm'

export function ChallengeList() {
  const { t } = useTranslation()
  const { data: challenges, isLoading, isError } = useChallenges()

  const active = (challenges ?? []).filter((challenge) => challenge.status === 'active')
  const past = (challenges ?? []).filter((challenge) => challenge.status !== 'active')

  return (
    <section aria-labelledby="challenges-title" className="flex flex-col gap-5">
      <h2 id="challenges-title" className="font-display text-lg font-semibold text-on-surface">
        {t('challenges.title')}
      </h2>

      <CreateChallengeForm />

      {isError && <Alert variant="error">{t('challenges.load_error')}</Alert>}
      {isLoading && <div className="h-24 animate-pulse rounded-2xl bg-surface-container" />}

      {challenges && challenges.length === 0 && (
        <p className="rounded-2xl bg-surface-low px-4 py-6 text-center text-sm text-on-surface-variant">
          {t('challenges.empty')}
          <span className="mt-1 block text-on-surface-variant">{t('challenges.empty_hint')}</span>
        </p>
      )}

      {active.length > 0 && (
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-semibold text-on-surface">{t('challenges.ongoing')}</h3>
          <ul className="flex flex-col gap-3">
            {active.map((challenge) => (
              <ChallengeCard key={challenge.id} challenge={challenge} />
            ))}
          </ul>
        </div>
      )}

      {past.length > 0 && (
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-semibold text-on-surface">{t('challenges.history')}</h3>
          <ul className="flex flex-col gap-3">
            {past.map((challenge) => (
              <ChallengeCard key={challenge.id} challenge={challenge} />
            ))}
          </ul>
        </div>
      )}
    </section>
  )
}
